var _a;
var JS_CHEM_STYLE_SELECTOR = '.js-chem-style-stats-selector';
var JS_CHEM_STYLE_JSON_DATA = '#js-chem-style-json-data';
var JS_PLAYER_DETAIL_STAT = '.js-player-detail-stat';
var JS_CHEM_STYLE_RESET = '#js-chem-style-reset';
var DIFFERENCE_SELECTOR = 'rating__value-difference';
var CALCULATED_SELECTOR = 'rating__value-calculated';
var ORIGINAL_SELECTOR = 'rating__value-original';
var JS_GROUP_SELECTOR = '.js-group-selector';
var JS_GROUP_OVERALL_CALCULATED = '.js-group-overall-calculated';
var JS_GROUP_OVERALL_ORIGINAL = '.js-group-overall-original';
var JS_GROUP_OVERALL_DIFFERENCE = '.js-group-overall-difference';
var JS_FUT_CARD = '.js-fut-card';
var JS_CHEM_POINTS_SELECTOR = '.js-chemistry-points-selector';
var JS_CHEM_POINT_SELECTOR = '.js-chemistry-point';
var ACC_RATE_STATS = ['attribute_acceleration', 'attribute_agility', 'attribute_strength'];
var ACCELERATE_ORIGINAL_VALUE_SELECTOR = '.js-accelerate-original-value';
var ACCELERATE_CALCULATED_VALUE_SELECTOR = '.js-accelerate-calculated-value';
var THRESHOLDS = {};
var thresholdEls = document.getElementById('pilf-attribute-threshold-groups');
if (thresholdEls) {
    THRESHOLDS = JSON.parse((_a = thresholdEls === null || thresholdEls === void 0 ? void 0 : thresholdEls.textContent) !== null && _a !== void 0 ? _a : "");
}
var ChemStyleSelectors = /** @class */ (function () {
    function ChemStyleSelectors(chemStyleSelectorEl, handlePressEvent, index) {
        if (index === void 0) { index = null; }
        this.chemStyleSelectorEl = null;
        this.playerDetailStatEl = null;
        this.chemStyleSelectorEl = chemStyleSelectorEl;
        this.chemStyleSelectorEl.addEventListener('click', function (evt) { return handlePressEvent(evt); });
    }
    return ChemStyleSelectors;
}());
var FaceStatCalculator = /** @class */ (function () {
    function FaceStatCalculator() {
        this.statGroupsEl = [];
        this.statGroupsEl = Array.from(document.querySelectorAll(JS_GROUP_SELECTOR));
    }
    FaceStatCalculator.prototype.reset = function () {
        this.statGroupsEl.forEach(function (statGroup) {
            var statGroupCalculatedEl = statGroup === null || statGroup === void 0 ? void 0 : statGroup.querySelector(JS_GROUP_OVERALL_CALCULATED);
            var statGroupOriginalEl = statGroup === null || statGroup === void 0 ? void 0 : statGroup.querySelector(JS_GROUP_OVERALL_ORIGINAL);
            statGroupCalculatedEl === null || statGroupCalculatedEl === void 0 ? void 0 : statGroupCalculatedEl.classList.add('rating__group-overall-hidden');
            statGroupCalculatedEl === null || statGroupCalculatedEl === void 0 ? void 0 : statGroupCalculatedEl.classList.remove('rating__group-overall-visible');
            if (statGroupOriginalEl) {
                statGroupOriginalEl.style.display = 'flex';
            }
        });
    };
    FaceStatCalculator.prototype.findAverage = function (statGroup) {
        var average = 0;
        statGroup.forEach(function (stat) {
            var _a, _b, _c;
            var calculatedValue = parseInt(((_a = stat === null || stat === void 0 ? void 0 : stat.querySelector(".".concat(CALCULATED_SELECTOR))) === null || _a === void 0 ? void 0 : _a.textContent) || '0');
            var originalValue = parseInt(((_b = stat === null || stat === void 0 ? void 0 : stat.querySelector(".".concat(ORIGINAL_SELECTOR))) === null || _b === void 0 ? void 0 : _b.textContent) || '0');
            var weight = parseFloat(((_c = stat === null || stat === void 0 ? void 0 : stat.dataset) === null || _c === void 0 ? void 0 : _c.weight) || '0');
            if (calculatedValue !== originalValue) {
                average += (calculatedValue * weight);
            }
            else {
                average += (originalValue * weight);
            }
        });
        return average;
    };
    FaceStatCalculator.prototype.calculate = function () {
        var _this = this;
        var cardFaceStats = [];
        this.statGroupsEl.forEach(function (statGroup, index) {
            var groupStatsEl = Array.from(statGroup === null || statGroup === void 0 ? void 0 : statGroup.querySelectorAll(JS_PLAYER_DETAIL_STAT));
            var statGroupCalculatedEl = statGroup === null || statGroup === void 0 ? void 0 : statGroup.querySelector(JS_GROUP_OVERALL_CALCULATED);
            var statGroupOriginal = statGroup === null || statGroup === void 0 ? void 0 : statGroup.querySelector(JS_GROUP_OVERALL_ORIGINAL);
            var statDifference = statGroup === null || statGroup === void 0 ? void 0 : statGroup.querySelector(JS_GROUP_OVERALL_DIFFERENCE);
            var originalAverageDisplay = parseInt((statGroupOriginal === null || statGroupOriginal === void 0 ? void 0 : statGroupOriginal.textContent) || '0');
            var calculatedAverage = _this.findAverage(groupStatsEl);
            var tmpTotal = calculatedAverage - originalAverageDisplay;
            if (tmpTotal % 1 > .5) {
                tmpTotal = Math.round(tmpTotal);
            }
            else {
                tmpTotal = Math.floor(tmpTotal);
            }
            tmpTotal = Math.max(tmpTotal, 0);
            calculatedAverage = originalAverageDisplay + tmpTotal;
            var difference = calculatedAverage - originalAverageDisplay;
            if (difference !== 0) {
                if (!statGroupCalculatedEl || !statGroupOriginal || !statDifference) {
                    return;
                }
                // handle showing the overall average
                statGroupCalculatedEl.innerHTML = calculatedAverage.toString();
                statGroupCalculatedEl === null || statGroupCalculatedEl === void 0 ? void 0 : statGroupCalculatedEl.classList.remove('rating__group-overall-hidden');
                statGroupCalculatedEl === null || statGroupCalculatedEl === void 0 ? void 0 : statGroupCalculatedEl.classList.add('rating__group-overall-visible');
                // handle showing the difference 
                statGroupOriginal.style.display = 'none';
                var maxedDifference = difference > 0 ? Math.min(difference, 99) : difference;
                statDifference.innerHTML = difference > 0 ? "+".concat(maxedDifference) : "".concat(difference);
                statDifference.classList.remove(difference < 0 ? "".concat(DIFFERENCE_SELECTOR, "-green") : "".concat(DIFFERENCE_SELECTOR, "-red"));
                statDifference.classList.add(difference > 0 ? "".concat(DIFFERENCE_SELECTOR, "-green") : "".concat(DIFFERENCE_SELECTOR, "-red"));
                statDifference.style.display = 'flex';
            }
            else {
                if (!statGroupCalculatedEl || !statDifference) {
                    return;
                }
                statDifference.innerHTML = '';
                statDifference.style.display = 'none';
                statGroupCalculatedEl.innerHTML = originalAverageDisplay.toString();
            }
            var label = statGroup.querySelector('.rating__group-overall h4');
            if (label) {
                cardFaceStats.push({
                    label: label === null || label === void 0 ? void 0 : label.textContent,
                    value: difference !== 0 ? calculatedAverage.toString() : originalAverageDisplay.toString(),
                    difference: difference
                });
            }
        });
        var futCardEl = document.querySelector(JS_FUT_CARD);
        if (futCardEl) {
            var chemStyleChangeEvt = new CustomEvent('chemStyleChange', {
                bubbles: true,
                detail: cardFaceStats
            });
            futCardEl.dispatchEvent(chemStyleChangeEvt);
        }
    };
    return FaceStatCalculator;
}());
export function chemStyleSelectorsInit() {
    var _a, _b;
    var points = 3;
    var styleName = '';
    var accRateParamValues = {};
    var chemStylesDataEl = document.querySelector(JS_CHEM_STYLE_JSON_DATA);
    var chemPointsEls = Array.from(document.querySelectorAll(JS_CHEM_POINTS_SELECTOR));
    var chemStatEls = Array.from(document.querySelectorAll(JS_CHEM_STYLE_SELECTOR));
    var chemStyleResetEl = document.querySelector(JS_CHEM_STYLE_RESET);
    if (!chemStylesDataEl || !chemStatEls || !chemStyleResetEl || !chemPointsEls) {
        return;
    }
    //get the main object data
    var chemStyleDataString = (_a = chemStylesDataEl === null || chemStylesDataEl === void 0 ? void 0 : chemStylesDataEl.dataset) === null || _a === void 0 ? void 0 : _a['chemStatsJson'];
    var chemStyleDataJson = JSON.parse(chemStyleDataString);
    var playerHeight = parseInt((_b = chemStylesDataEl === null || chemStylesDataEl === void 0 ? void 0 : chemStylesDataEl.dataset) === null || _b === void 0 ? void 0 : _b['playerHeight']);
    chemPointsEls.forEach(function (chemPointsEl) {
        chemPointsEl.addEventListener('click', handleChemStylePointsClick);
    });
    new ChemStyleSelectors(chemStyleResetEl, handleReset);
    chemStatEls.forEach(function (chemStyle, index) {
        new ChemStyleSelectors(chemStyle, handlePress, index);
    });
    function highlightButton(evt) {
        var _a;
        // if the chem points were clicked instead of a chem style ignore highlighting
        if ((_a = evt === null || evt === void 0 ? void 0 : evt.target) === null || _a === void 0 ? void 0 : _a.classList.contains(JS_CHEM_POINTS_SELECTOR.replace('.', ''))) {
            return;
        }
        chemStatEls === null || chemStatEls === void 0 ? void 0 : chemStatEls.forEach(function (chemStyle) {
            chemStyle.classList.remove('active');
        });
        var selected = evt === null || evt === void 0 ? void 0 : evt.target;
        selected === null || selected === void 0 ? void 0 : selected.classList.add('active');
    }
    function getStatFields() {
        var fields = chemStyleDataJson[styleName].stats.find(function (style) { return style.chemistry == points; });
        delete fields.icon;
        delete fields.is_gk;
        delete fields.name;
        return fields;
    }
    function removeClass(el, cssClass) {
        if (el.classList.contains(cssClass)) {
            el.classList.remove(cssClass);
        }
    }
    function addClass(el, cssClass) {
        if (!el.classList.contains(cssClass)) {
            el.classList.add(cssClass);
        }
    }
    function getAttributeThresholdColor(points) {
        var thresholds = Object.keys(THRESHOLDS);
        var color = THRESHOLDS[0];
        thresholds.forEach(function (threshold) {
            if (points > parseInt(threshold)) {
                color = THRESHOLDS[threshold];
            }
        });
        return color;
    }
    function handlePress(evt, skipHighlight) {
        var _a, _b;
        if (skipHighlight === void 0) { skipHighlight = false; }
        var statCalculator = new FaceStatCalculator();
        statCalculator.reset();
        if (!skipHighlight) {
            highlightButton(evt);
        }
        if ((_a = evt.currentTarget) === null || _a === void 0 ? void 0 : _a.dataset.styleName) {
            styleName = (_b = evt.currentTarget) === null || _b === void 0 ? void 0 : _b.dataset.styleName;
        }
        var fields = getStatFields();
        if (!fields) {
            return;
        }
        Object.keys(fields).forEach(function (key) {
            var value = fields[key];
            var el = document.querySelector("".concat(JS_PLAYER_DETAIL_STAT, "[data-attribute=\"").concat(key, "\"]"));
            var differenceEl = el === null || el === void 0 ? void 0 : el.querySelector('.' + DIFFERENCE_SELECTOR);
            var calculatedEl = el === null || el === void 0 ? void 0 : el.querySelector('.' + CALCULATED_SELECTOR);
            var originalEl = el === null || el === void 0 ? void 0 : el.querySelector('.' + ORIGINAL_SELECTOR);
            if (differenceEl) {
                removeClass(differenceEl, "".concat(DIFFERENCE_SELECTOR, "-green"));
                removeClass(differenceEl, "".concat(DIFFERENCE_SELECTOR, "-red"));
                if (value == 0 || value == null) {
                    calculatedEl.style.display = 'none';
                    originalEl.style.display = 'block';
                    differenceEl.style.display = 'none';
                    differenceEl.innerHTML = '';
                    calculatedEl.innerHTML = originalEl.textContent;
                    originalEl.style.backgroundColor = getAttributeThresholdColor(parseInt(originalEl.textContent));
                    if (isAccRateStat(key)) { // check if stat affects acceleRATE
                        accRateParamValues[key] = parseInt(originalEl.textContent);
                    }
                }
                if (value > 0) {
                    var total = parseInt(originalEl.textContent) + value;
                    var diff99 = total - 99;
                    var maxedValue = diff99 > 0 ? value - diff99 : value;
                    if (maxedValue > 0) {
                        differenceEl.innerHTML = "+".concat(maxedValue);
                        addClass(differenceEl, "".concat(DIFFERENCE_SELECTOR, "-green"));
                        differenceEl.style.display = 'block';
                    }
                    else {
                        differenceEl.innerHTML = '';
                        differenceEl.style.display = 'none';
                    }
                }
                if (value < 0) {
                    differenceEl.innerHTML = "".concat(value);
                    addClass(differenceEl, "".concat(DIFFERENCE_SELECTOR, "-red"));
                    differenceEl.style.display = 'block';
                }
                if (value !== 0) {
                    var total = parseInt(originalEl.textContent) + value;
                    calculatedEl.innerHTML = total >= 99 ? '99' : total;
                    calculatedEl.style.display = 'block';
                    calculatedEl.style.backgroundColor = getAttributeThresholdColor(parseInt(calculatedEl.innerHTML));
                    originalEl.style.display = 'none';
                    if (isAccRateStat(key)) { // check if stat affects acceleRATE
                        accRateParamValues[key] = parseInt(calculatedEl.textContent);
                    }
                }
            }
        });
        statCalculator.calculate();
        var accRate = calculateAccRate(playerHeight);
        if (accRate) {
            var accRateEl = document.querySelector(ACCELERATE_ORIGINAL_VALUE_SELECTOR);
            var originalAccRate = accRateEl === null || accRateEl === void 0 ? void 0 : accRateEl.textContent;
            if (accRateEl) {
                accRateEl.style.display = 'none';
                var accRateCalculatedEl = document.querySelector(ACCELERATE_CALCULATED_VALUE_SELECTOR);
                if (accRateCalculatedEl) {
                    accRateCalculatedEl.classList.remove('acc-rate-different');
                    accRateCalculatedEl.style.display = 'grid';
                    accRateCalculatedEl.innerHTML = (accRate === null || accRate === void 0 ? void 0 : accRate.toString()) || '';
                    var futCardEl = document.querySelector(JS_FUT_CARD);
                    var accelerateChangeEvt = new CustomEvent('accelerateChange', {
                        bubbles: true,
                        detail: { 'accelerate': accRate.trim() }
                    });
                    if (futCardEl) {
                        futCardEl.dispatchEvent(accelerateChangeEvt);
                    }
                    if (accRate.trim() != originalAccRate.trim()) {
                        accRateCalculatedEl.classList.add('acc-rate-different');
                    }
                }
            }
        }
    }
    function isAccRateStat(stat) {
        return ACC_RATE_STATS.includes(stat);
    }
    function handleReset(evt) {
        var differencesEl = Array.from(document === null || document === void 0 ? void 0 : document.querySelectorAll('.' + DIFFERENCE_SELECTOR));
        var calculatedEl = Array.from(document === null || document === void 0 ? void 0 : document.querySelectorAll('.' + CALCULATED_SELECTOR));
        var originalEl = Array.from(document === null || document === void 0 ? void 0 : document.querySelectorAll('.' + ORIGINAL_SELECTOR));
        var overallCalculatedEl = Array.from(document === null || document === void 0 ? void 0 : document.querySelectorAll(JS_GROUP_OVERALL_CALCULATED));
        var overallOriginalEl = Array.from(document === null || document === void 0 ? void 0 : document.querySelectorAll(JS_GROUP_OVERALL_ORIGINAL));
        var overallDifferenceEl = Array.from(document === null || document === void 0 ? void 0 : document.querySelectorAll(JS_GROUP_OVERALL_DIFFERENCE));
        differencesEl === null || differencesEl === void 0 ? void 0 : differencesEl.forEach(function (differenceEl) {
            differenceEl.innerHTML = '';
            differenceEl.classList.remove("".concat(DIFFERENCE_SELECTOR, "-green"));
            differenceEl.classList.remove(".".concat(DIFFERENCE_SELECTOR, "-red"));
        });
        overallDifferenceEl === null || overallDifferenceEl === void 0 ? void 0 : overallDifferenceEl.forEach(function (differenceEl) {
            differenceEl.innerHTML = '';
            // differenceEl.classList.remove(`${DIFFERENCE_SELECTOR}-green`);
            // differenceEl.classList.remove(`.${DIFFERENCE_SELECTOR}-red`);
        });
        calculatedEl === null || calculatedEl === void 0 ? void 0 : calculatedEl.forEach(function (calculatedEl) {
            calculatedEl.style.display = 'none';
        });
        overallCalculatedEl === null || overallCalculatedEl === void 0 ? void 0 : overallCalculatedEl.forEach(function (calculatedEl) {
            calculatedEl === null || calculatedEl === void 0 ? void 0 : calculatedEl.classList.add('rating__group-overall-hidden');
            calculatedEl === null || calculatedEl === void 0 ? void 0 : calculatedEl.classList.remove('rating__group-overall-visible');
        });
        originalEl === null || originalEl === void 0 ? void 0 : originalEl.forEach(function (originalEl) {
            originalEl.style.display = 'block';
        });
        overallOriginalEl === null || overallOriginalEl === void 0 ? void 0 : overallOriginalEl.forEach(function (originalEl) {
            originalEl.style.display = 'block';
        });
        chemStatEls === null || chemStatEls === void 0 ? void 0 : chemStatEls.forEach(function (chemStyle) {
            chemStyle.classList.remove('active');
        });
        var futCardEl = document.querySelector(JS_FUT_CARD);
        if (futCardEl) {
            var accelerateResetEvt = new CustomEvent('accelerateReset', { bubbles: true });
            var chemStyleChangeEvt = new CustomEvent('chemStyleReset', { bubbles: true });
            futCardEl.dispatchEvent(chemStyleChangeEvt);
            futCardEl.dispatchEvent(accelerateResetEvt);
        }
        var accRateEl = document.querySelector(ACCELERATE_ORIGINAL_VALUE_SELECTOR);
        if (accRateEl) {
            accRateEl.style.display = 'grid';
            var accRateCalculatedEl = document.querySelector(ACCELERATE_CALCULATED_VALUE_SELECTOR);
            if (accRateCalculatedEl) {
                accRateCalculatedEl.style.display = 'none';
            }
        }
    }
    function handleChemStylePointsClick(evt) {
        var currentChemPoint = evt.target;
        var parent = null;
        // check if the point or outer button is clicked
        if (currentChemPoint.classList.contains('chemistry-points__point') || currentChemPoint.classList.contains('chemistry-points__futgg-point')) {
            parent = currentChemPoint.parentElement;
        }
        else {
            parent = currentChemPoint;
        }
        if (!parent) {
            return;
        }
        points = parseInt(parent.dataset.chemistryPoints);
        var pointsEls = Array.from(document.querySelectorAll(JS_CHEM_POINT_SELECTOR));
        pointsEls.forEach(function (pointEl) {
            pointEl.classList.remove('chemistry-points__futgg-point');
            pointEl.classList.add('chemistry-points__point');
            if (pointEl.classList.contains('chemistry-points__futgg-point--is-active')) {
                pointEl.classList.remove('chemistry-points__futgg-point--is-active');
                pointEl.classList.add('chemistry-points__point--is-active');
            }
        });
        var clickedPointsEls = Array.from(parent.querySelectorAll(JS_CHEM_POINT_SELECTOR));
        clickedPointsEls.forEach(function (pointEl) {
            pointEl.classList.remove('chemistry-points__point');
            pointEl.classList.add('chemistry-points__futgg-point');
            if (pointEl.classList.contains('chemistry-points__point--is-active')) {
                pointEl.classList.remove('chemistry-points__point--is-active');
                pointEl.classList.add('chemistry-points__futgg-point--is-active');
            }
        });
        //     let pointEls: Array<HTMLElement> = Array.from(currentChemPoint.parentElement?.querySelectorAll('.chemistry-points__futgg-point') || [])
        //    pointEls.forEach((point: HTMLElement) => {
        //         point.classList.remove('chemistry-points__point--active');
        //         point.classList.remove('.chemistry-points__point');
        //          point.classList.remove('chemistry-points__point--active');
        //         point.classList.remove('.chemistry-points__point');
        //     })  
        // chemPointsEl.style.height = '60px';
        // chemPointsEl.style.width = '60px'; 
        if (styleName !== '') {
            handlePress(evt, true);
        }
    }
    function calculateAccRate(height) {
        var acceleration = accRateParamValues.attribute_acceleration, agility = accRateParamValues.attribute_agility, strength = accRateParamValues.attribute_strength;
        if (!acceleration || !height) {
            return '';
        }
        if (agility >= 65 && (agility - strength) >= 15 && acceleration >= 74 && height <= 180) {
            return 'Explosive';
        }
        else if (strength >= 65 && (strength - agility) >= 14 && acceleration >= 55 && height >= 174) {
            return 'Lengthy';
        }
        return 'Controlled';
    }
}
